import request from '@/utils/request'; // 获取楼宇层级树(areagroupId)

export function fetchTreeList(data) {
  return request({
    url: '/pmsservice/api/pmsTree/selectPmsTree',
    method: 'post',
    data: data
  });
}
export function fetchHouseTreeList(data) {
  return request({
    url: '/pmsservice/api/publicMethod/houseTreeList',
    method: 'post',
    data: data
  });
} // 获取房屋的树

export function selectZhlgPmsTree(data) {
  return request({
    url: '/pmsservice/api/pmsTree/selectZhlgPmsTree',
    method: 'post',
    data: data
  });
} // // 添加单位房屋的树
// export function insertCompanyHouse(data) {
//   return request({
//     url: '/pmsservice/api/unitManagement/insertCompanyHouse',
//     method: 'post',
//     data
//   })
// }
// 添加单位房屋的树

export function insertCompanyHouse(data) {
  return request({
    url: '/pmsservice/api/customerOa/insertCompanyHouse',
    method: 'post',
    data: data
  });
} // // 查询单位房屋
// export function getCompanyHouseList(data) {
//   return request({
//     url: '/pmsservice/api/unitManagement/getCompanyHouseList',
//     method: 'post',
//     data
//   })
// }
// 查询单位房屋

export function getCompanyHouseList(data) {
  return request({
    url: '/pmsservice/api/customerOa/getCompanyHouseList',
    method: 'post',
    data: data
  });
} // 获取楼宇层级树(areaId)

export function fetchTree(data) {
  return request({
    url: '/pmsservice/api/pmsTree/selectPmsTreeWithArea',
    method: 'post',
    data: data
  });
} // fetchTreeList

export function selectPmsTreeNumber(data) {
  return request({
    url: '/pmsservice/api/pmsTree/selectPmsTreeNumber',
    method: 'post',
    data: data
  });
}
export function selectManagerArea() {
  return request({
    url: '/pmsservice/api/area/selectManagerArea',
    method: 'post'
  });
}
export function selectAreaClassify(data) {
  return request({
    url: '/pmsservice/api/area/selectAreaClassify',
    method: 'post',
    data: data
  });
}
export function publicDicTreeList(data) {
  return request({
    url: '/pmsservice/api/publicDic/treeList',
    method: 'post',
    data: data
  });
} // 获取楼宇树

export function selectAreaCityNode(data) {
  return request({
    url: '/pmsservice/api/pmsTree/selectAreaCityNode',
    method: 'post',
    data: data
  });
}